// extracted by mini-css-extract-plugin
export default {"root":"UserItem_root__0N93F","checkbox":"UserItem_checkbox__SpZEN","icon":"UserItem_icon__V5Eqo","name":"UserItem_name__Nkd0H","selected":"UserItem_selected__hz7X+"};